import Client from 'shopify-buy'
import WCC from 'wcc'

const globalConstants = WCC && WCC.WMR_CONSTANTS ? WCC.WMR_CONSTANTS : {}

export const client = Client.buildClient({
  storefrontAccessToken: globalConstants.SHOPIFY_STOREFRONT_API_KEY,
  domain: globalConstants.SHOPIFY_DOMAIN,
})
